import { render, staticRenderFns } from "./ScrollContainer.vue?vue&type=template&id=45d10360&scoped=true"
import script from "./ScrollContainer.vue?vue&type=script&lang=js"
export * from "./ScrollContainer.vue?vue&type=script&lang=js"
import style0 from "./ScrollContainer.vue?vue&type=style&index=0&id=45d10360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d10360",
  null
  
)

export default component.exports